export type EcosystemImage = {
  src: string
  alt: string
}

export type EcosystemEntry = {
  slug: string
  name: string
  /** Concise label describing the entry's actual relationship to SyNeural. */
  relationship: string
  description: string
  cta: string
  href: string
  /** Approved artwork. Entries without one show a simple text wordmark. */
  image?: EcosystemImage
}

export const cognocracyEmblem: EcosystemImage = {
  src: 'https://cdn.magicpatterns.com/uploads/iXpXHQbF6kpmfU4rAP7pkL/Monochrome_emblem_with_ascending_steps.png',
  alt: 'Cognocracy emblem representing connected judgment, civic participation and human development.',
}

export const ecosystemEntries: EcosystemEntry[] = [
  {
    slug: 'cognocracy',
    name: 'Cognocracy',
    relationship: 'Civic governance initiative',
    description:
      'Exploring how connected knowledge, human development and institutional learning can support civic governance.',
    cta: 'Explore Cognocracy',
    href: '/ecosystem/cognocracy',
    image: cognocracyEmblem,
  },
  {
    slug: 'calmir',
    name: 'CalMiR',
    relationship: 'Independent affiliate ecosystem',
    description:
      'Connecting research and organizational workflows through shared SyNeural infrastructure, with dedicated workspaces for independently owned affiliates.',
    cta: 'Explore CalMiR',
    href: '/ecosystem/calmir',
  },
]

export const calmirBenefits = [
  {
    title: 'Reuse infrastructure',
    body: 'Build on common technical services instead of duplicating every component.',
  },
  {
    title: 'Maintain independence',
    body: 'Keep organizational responsibilities, workspace access and data governance distinct.',
  },
  {
    title: 'Coordinate selected work',
    body: 'Connect relevant knowledge and workflows through explicitly configured sharing and review.',
  },
]

export const calmirComponents = [
  {
    name: 'Semantic Knowledge Platform',
    body: 'Organizes sources, concepts and reviewed relationships for research and institutional knowledge.',
    href: '/semantic-knowledge',
  },
  {
    name: 'Noetivra Core',
    body: 'Intended shared foundation for workflow services, integrations and access management.',
    href: '/how-it-works#noetivra-core',
  },
  {
    name: 'Noetivra Workspace',
    body: 'Dedicated organizational environments for reviewing information and coordinating work.',
    href: '/noetivra',
  },
  {
    name: 'Configured modules',
    body: 'Relevant functions selected for each organization rather than one universal configuration.',
    href: '/how-it-works#modules',
  },
]
